// material import
import {
    Breadcrumbs,
    Button,
    Checkbox,
    Container,
    FormControlLabel,
    Grid,
    Link,
    Switch
} from '@material-ui/core';
import { React } from "react";
import { legal_agreement_eula } from '../../common/constants/constants';
import PageHeader from '../../components/pageHeader/pageHeader';

const Eula = (props) => {
    return (
        <article>
            <PageHeader h1={legal_agreement_eula.title} legal={legal_agreement_eula} />
            <Container maxWidth="md" className="container-align-left">
                <Grid container spacing={3} className="legal-container">
                    <Grid item xs={12} md={12} lg={12}>
                        <div><img src={legal_agreement_eula.logo} alt={legal_agreement_eula.logoAlt}  style={{ maxWidth: '40%', marginBottom: '20px'  }}/></div>
                        <div className="legal-content" dangerouslySetInnerHTML={{ __html: legal_agreement_eula.legalText }}></div>
                    </Grid>
                </Grid>
            </Container>
        </article>                
    );
};

export default Eula;

